import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'shared/components/accordion/accordion.module';

import { PromptuaryTaskDescription } from './promptuary-task-description.component';

@NgModule({
	declarations: [PromptuaryTaskDescription],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		AccordionModule,
	],
	exports: [PromptuaryTaskDescription],
})
export class PromptuaryTaskDescriptionModule {}
